import { useMemo } from "react";
import { motion } from "framer-motion";

// The 5 "hero" prints the user wants pinned to the top of the archive.
const topShots = [
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/77w2var1_IMG_5193.jpeg",
    tag: "Karelyn & Nayeli · Vogue · 09.06.26",
    span: "md:col-span-5",
    aspect: "aspect-[2/3]",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/l28lf6wm_IMG_5211.jpeg",
    tag: "Karelyn & Nayeli · Vogue",
    span: "md:col-span-4",
    aspect: "aspect-[2/3]",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/rtiis80e_IMG_4814.jpeg",
    tag: "Sophia Marie XV",
    span: "md:col-span-3",
    aspect: "aspect-[2/5]",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/nqiz3xiz_IMG_4813.jpeg",
    tag: "Jared & Brenda · Wedding 5.23.26",
    span: "md:col-span-7",
    aspect: "aspect-[3/2]",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/su8iiv1m_IMG_4298.jpeg",
    tag: "Evelyn's Baby Shower · 06.20.26",
    span: "md:col-span-5",
    aspect: "aspect-[3/2]",
  },
];

// Everything else — shuffled on each visit.
const restShots = [
  // Newest additions
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/fab6cd7ff0137ed4_IMG_3551.jpeg",
    tag: "EMMG · The Holiday Issue · 12.20.25",
    span: "md:col-span-4",
    aspect: "aspect-[2/3]",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/e4b21f55296a39b6_IMG_5743.jpeg",
    tag: "EMMG · 'Tis The Vibe",
    span: "md:col-span-4",
    aspect: "aspect-[2/3]",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/e8867856d2472d26_IMG_5744.jpeg",
    tag: "Alexa's Graduation · 05.16.26",
    span: "md:col-span-4",
    aspect: "aspect-[2/3]",
  },
  // Newest 5 additions
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/i2z3i48v_IMG_5375.jpeg",
    tag: "Brenda & Jared · Wedding Vogue",
    span: "md:col-span-4",
    aspect: "aspect-[2/3]",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/xxxj4sfl_IMG_2049.jpeg",
    tag: "Brenda & Jared · Strip 5.23.26",
    span: "md:col-span-3",
    aspect: "aspect-[2/5]",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/z89eusog_IMG_2051.jpeg",
    tag: "Brenda & Jared · Strip",
    span: "md:col-span-3",
    aspect: "aspect-[2/5]",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/vw10cqxt_IMG_5371.jpeg",
    tag: "Sophie's Eighteen · 11.28.25",
    span: "md:col-span-3",
    aspect: "aspect-[2/5]",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/5yd7ia0w_IMG_5370.jpeg",
    tag: "Sophie's Eighteen",
    span: "md:col-span-3",
    aspect: "aspect-[2/5]",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/y4wuu57o_IMG_4458.jpeg",
    tag: "Mairin's Quinceañera · July 10, 2026",
    span: "md:col-span-7",
    aspect: "aspect-[3/2]",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/gqhejjb9_IMG_4461.jpeg",
    tag: "Mairin's 15 · Vogue",
    span: "md:col-span-5",
    aspect: "aspect-[2/3]",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/4yil4wjj_IMG_4465.jpeg",
    tag: "Mairin's 15 · Vogue",
    span: "md:col-span-4",
    aspect: "aspect-[2/3]",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/zlmch4go_IMG_4298.jpeg",
    tag: "Evelyn's Baby Shower · 06.20.26",
    span: "md:col-span-4",
    aspect: "aspect-[2/3]",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/to1v154z_IMG_4281.jpeg",
    tag: "Evelyn's Baby Shower · strip",
    span: "md:col-span-4",
    aspect: "aspect-[3/2]",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/uai6onr1_IMG_4487.jpeg",
    tag: "Quinceañera · Roxana",
    span: "md:col-span-5 md:row-span-2",
    aspect: "aspect-[4/5]",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/bj30hann_IMG_4805.jpeg",
    tag: "Brianna's XV · 06.19.26",
    span: "md:col-span-7",
    aspect: "aspect-[3/2]",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/pw7ntx41_IMG_4806.jpeg",
    tag: "Sophia Marie XV",
    span: "md:col-span-4",
    aspect: "aspect-[2/5]",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/cvvhassw_IMG_0987.jpeg",
    tag: "Litzy & Miguel · Wedding 9.12.25",
    span: "md:col-span-8",
    aspect: "aspect-[3/2]",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/vcktb93w_IMG_4811.jpeg",
    tag: "Brenda & Jared · 05.23.26",
    span: "md:col-span-4",
    aspect: "aspect-[1/2]",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/f97z07ai_IMG_4815.jpeg",
    tag: "Bellagrace · Sweet XVI",
    span: "md:col-span-4",
    aspect: "aspect-[2/5]",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/luryun59_IMG_4486.jpeg",
    tag: "Liliana's Quinceañera",
    span: "md:col-span-4",
    aspect: "aspect-[3/4]",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/kditxv1n_IMG_4576.jpeg",
    tag: "Liliana's Quinceañera",
    span: "md:col-span-3",
    aspect: "aspect-[3/4]",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/z446fzat_IMG_4587.jpeg",
    tag: "Mairin's 15 · Vogue",
    span: "md:col-span-4",
    aspect: "aspect-[3/4]",
  },
  {
    url: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/60u1pigf_IMG_4630.jpeg",
    tag: "Mairin's 15 · Family",
    span: "md:col-span-3",
    aspect: "aspect-[3/4]",
  },
  {
    url: "https://bc-user-uploads.brandcrowd.com/public/media-Production/4e66984e-ccb1-4743-b5bf-abeb6dbac48e/17a73222-aea6-490c-90e0-7fa9483827cf_2x",
    tag: "Wedding · Mirror booth",
    span: "md:col-span-5 md:row-span-2",
    aspect: "aspect-[4/5]",
  },
  {
    url: "https://bc-user-uploads.brandcrowd.com/public/media-Production/4e66984e-ccb1-4743-b5bf-abeb6dbac48e/868d44ab-608a-48ae-82df-212f65209d91_2x",
    tag: "Quinceañera · Chicago",
    span: "md:col-span-4",
    aspect: "aspect-[4/3]",
  },
  {
    url: "https://bc-user-uploads.brandcrowd.com/public/media-Production/4e66984e-ccb1-4743-b5bf-abeb6dbac48e/eae8e186-3c23-446b-ba6f-718ab8d6775c_2x",
    tag: "Studio print",
    span: "md:col-span-3",
    aspect: "aspect-[3/4]",
  },
  {
    url: "https://bc-user-uploads.brandcrowd.com/public/media-Production/4e66984e-ccb1-4743-b5bf-abeb6dbac48e/7b61475c-2826-480e-b984-20372cd7674b_2x",
    tag: "Birthday · Suburbs",
    span: "md:col-span-4",
    aspect: "aspect-[4/3]",
  },
  {
    url: "https://bc-user-uploads.brandcrowd.com/public/media-Production/4e66984e-ccb1-4743-b5bf-abeb6dbac48e/a8569205-e424-4cfb-8568-68b80ab9e9a7_2x",
    tag: "Corporate · Downtown",
    span: "md:col-span-3",
    aspect: "aspect-[3/4]",
  },
  {
    url: "https://bc-user-uploads.brandcrowd.com/public/media-Production/4e66984e-ccb1-4743-b5bf-abeb6dbac48e/006a1a43-1bbe-461b-9325-a6d4b5397bef_2x",
    tag: "Ceremony · Estate",
    span: "md:col-span-5",
    aspect: "aspect-[16/9]",
  },
];

const reveal = {
  initial: { y: 50, opacity: 0 },
  whileInView: { y: 0, opacity: 1 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] },
};

export default function Portfolio() {
  const shots = useMemo(() => {
    // Fisher-Yates shuffle of restShots on each mount
    const arr = [...restShots];
    for (let i = arr.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return [...topShots, ...arr];
  }, []);

  return (
    <section id="portfolio" className="relative bg-[#FDFBF7] py-24 md:py-40" data-testid="portfolio-section">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <motion.div {...reveal} className="flex items-end justify-between mb-14 md:mb-20">
          <div>
            <div className="overline text-[#0A0A0A]/60 mb-4">The Archive</div>
            <h2 className="font-serif font-light text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight text-[#0A0A0A]">
              A year in <em className="text-[#FF5722]">portraits</em>.
            </h2>
          </div>
          <a
            href="#booking"
            className="hidden md:inline-flex items-center gap-3 text-sm border-b border-[#0A0A0A]/40 pb-1 hover:border-[#FF5722] hover:text-[#FF5722] transition-colors"
            data-testid="portfolio-inquire"
          >
            Inquire about your event →
          </a>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-12 gap-4 md:gap-6 auto-rows-auto">
          {shots.map((s, i) => (
            <motion.figure
              key={i}
              {...reveal}
              transition={{ ...reveal.transition, delay: i * 0.06 }}
              className={`${s.span} relative overflow-hidden rounded-sm group bg-[#F1EEE6] flex items-center justify-center`}
              data-testid={`portfolio-item-${i}`}
            >
              <img
                src={s.url}
                alt=""
                loading="lazy"
                className="max-w-full max-h-[70vh] w-auto h-auto object-contain transition-transform duration-[1100ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.03]"
              />
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
